export default __webpack_public_path__ + "static/media/DownloadFromCloud.15e3cf3f.svg";